import OliverText from "@builder/components/general/OliverText";
import "./style.scss";
import { useTranslation } from "react-i18next";

const EditableInfo = ({
    header,
    body,
    body2,
    noTranslate,
    bulletPoints,
    paragraphs
}: {
    header?: string;
    body?: string;
    body2?: string;
    noTranslate?: boolean;
    bulletPoints?: { points: string[]; title: string };
    paragraphs?: string[];
}) => {
    const { t } = useTranslation();
    const translation = noTranslate ? (text: string) => text : (text: string) => t("editableInfo." + text);

    return (
        <div className="editable-info">
            {header && <OliverText text={translation(header)} size="xs" weight="semi-bold" />}
            {body && <OliverText text={translation(body)} size="xs" />}
            {body2 && <OliverText text={translation(body2)} size="xs" style={{ marginTop: "12px" }} />}
            {paragraphs && paragraphs.length > 0 && (
                <div className="paragraphs-container">
                    {paragraphs.map((paragraph, index) => (
                        <OliverText key={index} text={translation(paragraph)} size="xs" />
                    ))}
                </div>
            )}
            {bulletPoints && bulletPoints.points.length > 0 && (
                <>
                    <OliverText text={translation(bulletPoints.title)} size="xs" />
                    <ul className="bullet-points-list">
                        {bulletPoints.points.map((point, index) => (
                            <li key={index}>
                                <OliverText text={translation(point)} size="xs" />
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default EditableInfo;
